var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"img",attrs:{"src":require('@/assets/' + _vm.image)}}),_c('div',{staticClass:"clock-coutdown"},[_c('span',[_vm._v(_vm._s(_vm.time))])]),_c('div',{staticClass:"snap-text",style:('top:' + _vm.position + 'px')},[_c('span',{staticClass:"txt_snap-text"},[_vm._v(_vm._s(_vm.$t(_vm.message)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }